import { IonicModule } from '@ionic/angular';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ChallengeImproveComponent } from './challenge-improve.component';
// import { ChallengeImproveComponentRoutingModule } from './challenge-improve-routing.module';
import { HelpersModule } from '../../helpers/helpers.module';
@NgModule({
	imports: [
		IonicModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		// ChallengeImproveComponentRoutingModule,
		HelpersModule,
	],
	declarations: [ChallengeImproveComponent],
	exports: [ChallengeImproveComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ChallengeImproveModule {}
